import { render, staticRenderFns } from "./InputCheckBox.vue?vue&type=template&id=8658dc94&scoped=true&"
import script from "./InputCheckBox.vue?vue&type=script&lang=js&"
export * from "./InputCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./InputCheckBox.vue?vue&type=style&index=0&id=8658dc94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8658dc94",
  null
  
)

export default component.exports